import React, { useEffect, useRef, useState } from 'react';
import { formController } from '../controllers/formController';
import generalController from '../controllers/generalController';
import * as Components from './Components';

function App() {
  const appRef = useRef(null);
  const [targetComponent, setTargetComponent] = useState(null);
  const [formExtraParams, setFormExtraParams] = useState({});

  useEffect(() => {
    // Get parent hidden inputs
    const formExtraParams = formController.getParentHiddenInputs(appRef.current);

    if (formExtraParams.formType) {
      // Get and add the current lang code
      const lang = generalController.detectLanguage()
      formExtraParams.language = lang;

      const formComponentKey = `${formExtraParams.formType}_Block`;

      if (formComponentKey in Components) {
        // Set the target component to be rendered
        setTargetComponent(formComponentKey)
        // Set formExtraParams except 'formType'
        const { formType, ...formExtraParamsRest } = formExtraParams
        setFormExtraParams(formExtraParamsRest)
      } else {
        console.log(`Error: FormType, "${formExtraParams.formType}", is not found.`)
      }
    }
  }, [])

  const Component = targetComponent ? Components[targetComponent] : null;

  return (
    <div className="App" ref={appRef}>
      {
        Component && <Component formExtraParams={formExtraParams} />
      }
    </div>
  );
}

export default App;
